import {
  MdHome,
  MdCategory,
  MdSchool,
  MdOutlineEdit,
  MdOutlineCancel,
  MdOutlineThumbUp,
  //MdOutlinePublish,
  MdOutlineCheckCircle,
  MdPeople,
  MdAdminPanelSettings,
  MdNoteAdd,
  MdShare,
  MdList,
  MdPersonAdd,
} from "react-icons/md";

import Dashboard from "./views/admin/default";
import Utilisateurs from "./views/admin/utilisateurs";
import Auteurs from "./views/admin/auteurs";
import Secretaires from "./views/admin/secretaires";
import Rubriques from "./views/admin/rubriques";
import Affiliation from "./views/admin/affiliation";
import ArticleNouveaux from "./views/admin/articles_nouveaux";
import ArticlesPartage from "./views/admin/articles_partage";
import ArticlesRemanie from "./views/admin/articles_remanie";
import ArticlePubliable from "views/admin/articles_publiable";
import ArticlePublier from "views/admin/articles_publier";
import ArticleRefuse from "./views/admin/articles_refuses";
import Profile from "views/admin/profile";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    requiredRole:
      "Administrateur || Secrétaire de direction || Auteur || Relecteur",
    component: <Dashboard />,
  },
  {
    name: "Gestion des relecteurs",
    layout: "/admin",
    path: "relecteurs",
    icon: <MdPeople className="h-6 w-6" />,
    requiredRole: "Administrateur || Secrétaire de direction",
    component: <Utilisateurs />,
    secondary: true,
  },
  {
    name: "Gestion des sécretaires",
    layout: "/admin",
    path: "secretaire",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    requiredRole: "Administrateur",
    component: <Secretaires />,
  },
  {
    name: "Gestion des Auteurs",
    layout: "/admin",
    path: "auteurs",
    icon: <MdPersonAdd className="h-6 w-6" />,
    requiredRole: "Administrateur",
    component: <Auteurs />,
  },
  {
    name: "Gestion des rubriques",
    layout: "/admin",
    path: "rubriques",
    icon: <MdCategory className="h-6 w-6" />,
    requiredRole: "Administrateur || Secrétaire de direction",
    component: <Rubriques />,
  },
  {
    name: "Gestion des affiliation",
    layout: "/admin",
    path: "affiliation",
    icon: <MdSchool className="h-6 w-6" />,
    requiredRole: "Administrateur",
    component: <Affiliation />,
  },
  {
    name: "Nouveaux articles",
    layout: "/admin",
    path: "articles/nouveaux",
    requiredRole:
      "Administrateur || Secrétaire de direction || Auteur || Relecteur",
    component: <ArticleNouveaux />,
    icon: <MdNoteAdd className="h-6 w-6" />,
  },
  {
    name: "Articles en cours d’évaluation",
    layout: "/admin",
    path: "articles/partages",
    requiredRole: "Administrateur || Secrétaire de direction || Auteur",
    component: <ArticlesPartage />,
    icon: <MdShare className="h-6 w-6" />,
  },
  {
    name: "Listes des articles",
    layout: "/admin",
    icon: <MdList className="h-6 w-6" />,
    secondary: true,
    requiredRole: "Administrateur || Secrétaire de direction || Auteur",
    isAccordion: true,
    children: [
      {
        name: "Articles a remanier",
        layout: "/admin",
        path: "articles/remanie",
        requiredRole: "Administrateur || Secrétaire de direction || Auteur",
        component: <ArticlesRemanie />,
        icon: <MdOutlineEdit className="h-6 w-6 text-amber-500" />,
      },
      {
        name: "Articles refusés",
        layout: "/admin",
        path: "articles/refuses",
        requiredRole: "Administrateur || Secrétaire de direction || Auteur",
        component: <ArticleRefuse />,
        icon: <MdOutlineCancel className="h-6 w-6 text-red-500" />,
      },
      {
        name: "Articles publiables",
        layout: "/admin",
        path: "articles/publiables",
        requiredRole: "Administrateur || Secrétaire de direction || Auteur",
        component: <ArticlePubliable />,
        icon: <MdOutlineThumbUp className="h-6 w-6 text-blue-500" />,
      },
      /*  {
        name: "Articles en cours de publication",
        layout: "/admin",
        path: "articles/en_cours",
        requiredRole: "Administrateur || Secrétaire de direction || Auteur",
        component: <Articles data="en_cours" statusId={4} />,
        icon: <MdOutlinePublish className="h-6 w-6 text-indigo-500" />,
      },
     */
      {
        name: "Articles publiés",
        layout: "/admin",
        path: "articles/publies",
        requiredRole: "Administrateur || Secrétaire de direction || Auteur",
        component: <ArticlePublier />,
        icon: <MdOutlineCheckCircle className="h-6 w-6 text-green-500" />,
      },
    ],
  },
  {
    name: "Profil d'utilisateur",
    layout: "/admin",
    path: "profil",
    requiredRole:
      "Administrateur || Secrétaire de direction || Auteur || Relecteur",
    component: <Profile />,
    icon: <MdOutlineEdit className="h-6 w-6" />,
    isShow: false,
  },
];

export default routes;
